import { PlusOutlined } from "@ant-design/icons";
import { Button, Form, Input, Select } from "antd";
import axios from "axios";
import _, { debounce } from "lodash";
import React, { useCallback, useEffect, useRef, useState } from "react";
import { useParams } from "react-router";
import { authenticateToken } from "../../utils/auth";
import { responseNotification } from "../../utils/notify";
const { Option } = Select;

const AddRegion = ({ visibleData, onCloseMethod, inHub = false }: any) => {
  const [form] = Form.useForm();
  const [form2] = Form.useForm();
  const route = useParams();

  const [loading, setLoading] = useState(false);
  const [type, setType] = useState("JC_MART");
  const [addRegion, setAddRegion] = useState(false);
  const [regionData, setRegionData] = useState(undefined);
  const [regionsOptions, setRegionsOptions] = useState<any>({
    list: [],
    loading: false,
  });

  const [hubsOptions, setHubsOptions] = useState<any>({
    list: [],
    loading: false,
  });

  const fetchRef = useRef(null);

  const onSubmit = async (data: any) => {
    setLoading(true);

    const readyData = data && {
      name: data.name,
      isActive: data.isActive,
      // hubId: inHub ? (route as any).hubId : data.hubId,
    };

    if (!addRegion) {
      if (regionData) {
        await fetch(`${process.env.REACT_APP_CATALOG_WRITER_API}/region`, {
          method: "PUT",
          headers: {
            Authorization: `Bearer ${authenticateToken()}`,
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            ...readyData,
            id: regionData?.id,
            isActive: true,
          }),
        })
          .then((res) => res.json())
          .then((res) => {
            setLoading(false);

            if (res.statusCode === 200) {
              responseNotification("Region Updated Successfully", "success");
              form.resetFields();
              if (onCloseMethod) {
                onCloseMethod();
              }
            } else if (res.status === 500) {
              responseNotification("Internal server error", "error");
            } else {
              responseNotification(res.message || "something wrong", "warning");
            }
          })
          .catch((err) => {
            setLoading(false);
            responseNotification(`${"Internal server error"} ${err}`, "error");
            console.error("err", err);
          });
      } else {
        await fetch(`${process.env.REACT_APP_CATALOG_WRITER_API}/region`, {
          method: "POST",
          headers: {
            Authorization: `Bearer ${authenticateToken()}`,
            "Content-Type": "application/json",
          },
          body: JSON.stringify(readyData),
        })
          .then((res) => res.json())
          .then((res) => {
            setLoading(false);

            if (res.statusCode === 200) {
              responseNotification("Region Created Successfully", "success");
              form.resetFields();
              if (onCloseMethod) {
                onCloseMethod();
              }
            } else if (res.status === 500) {
              responseNotification("Internal server error", "error");
            } else {
              responseNotification(res.message || "something wrong", "warning");
            }
          })
          .catch((err) => {
            setLoading(false);
            responseNotification(`${"Internal server error"} ${err}`, "error");
            console.error("err", err);
          });
      }
    } else {
      responseNotification(`Adding region operation is uncomplete`, "error");
    }
  };

  const getRegionsOptions = useCallback(
    async (val?: string) => {
      setRegionsOptions({ loading: true, list: [] });

      const res = await axios.get(
        `${process.env.REACT_APP_CATALOG_READER_API}/region?` +
          (type ? `&type=${type}` : ``) +
          (val ? `&key=${val}` : ``),
        {
          headers: {
            Authorization: `Bearer ${authenticateToken()}`,
          },
        }
      );
      setRegionsOptions({
        loading: false,
        list: res?.data?.regions?.map((region: any) => {
          return {
            value: region?.id,
            label: region?.name,
          };
        }),
      });
    },
    [type]
  );

  const AddRegionSubmit = async (data: any) => {
    setLoading(true);

    await fetch(`${process.env.REACT_APP_CATALOG_WRITER_API}/region`, {
      method: "POST",
      headers: {
        Authorization: `Bearer ${authenticateToken()}`,
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        name: data.regionName,
      }),
    })
      .then((res) => res.json())
      .then((res) => {
        setLoading(false);

        if (res.statusCode === 200) {
          responseNotification("Region Added Successfully", "success");
          form2.resetFields();
          getRegionsOptions();
          setAddRegion(false);
        } else if (res.status === 500) {
          responseNotification("Internal server error", "error");
        } else {
          responseNotification(res.message || "something wrong", "warning");
        }
      })
      .catch((err) => {
        setLoading(false);
        responseNotification(`${"Internal server error"} ${err}`, "error");
        console.error("err", err);
      });
  };

  const handleSearch = React.useMemo(() => {
    const loadOptions = (value: string, field: string) => {
      fetchRef.current += 1;
      const fetchId = fetchRef.current;

      if (fetchId !== fetchRef.current) {
        return;
      }
      if (value) {
        if (field === "region") getRegionsOptions(value);
      }
    };

    return debounce(loadOptions, 800);
  }, [getRegionsOptions]);

  useEffect(() => {
    getRegionsOptions();
  }, [getRegionsOptions]);

  useEffect(() => {
    if (visibleData) {
      setRegionData(visibleData);
    }
  }, [visibleData]);

  useEffect(() => {
    if (regionData) {
      form?.resetFields(Object.keys(visibleData));
    }
    form?.resetFields();
  }, [regionData]);

  return (
    <>
      <Form
        name="control-hooks"
        labelCol={{ span: 24 }}
        wrapperCol={{ span: 24 }}
        className="ant-form ant-form-vertical"
        onFinish={onSubmit}
        form={form} // like ref
        layout="vertical"
        autoComplete="off"
        initialValues={{
          ...regionData,
        }}
      >
        <Form.Item
          hasFeedback
          label={`Thana`}
          rules={[
            {
              required: true,
              message: "Region is Required!",
            },
          ]}
          name="name"
        >
          <Input id="name" type="text" placeholder="Enter Name" />
        </Form.Item>

        <div className="buttons-container">
          <Button
            disabled={loading}
            loading={(loading ? "loading" : undefined) as any}
            type="primary"
            htmlType="submit"
            className="add-submit-btn text-center mr-2"
          >
            Submit
          </Button>
          <Button
            type="ghost"
            htmlType="button"
            onClick={() => form?.resetFields()}
            className="reset-submit-btn text-center mr-2"
          >
            Reset
          </Button>
        </div>
      </Form>
    </>
  );
};

export default AddRegion;
